import { ServiceFetch } from '../service-fetch'

export default class PromotionDiscountListModel extends ServiceFetch {
    getPromotionDiscountListBy = (data) => this.authFetch({
        url: 'promotion-discount-list/getPromotionDiscountListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}